import React from 'react';
import './InstitutionalWithLogos.css';

const InstitutionalWithLogos = ({ section, isRightAligned }) => {
  if (!section) return null;

  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3030';
  const displayItems = section.items || [];
  
  // Alinhamentos dinâmicos respeitando as classes do seu CSS principal
  const alignClass = isRightAligned ? "section-header-right mb-3 pb-4" : "mb-3 pb-4";
  const revealDirection = isRightAligned ? "reveal-from-left" : "reveal-from-right";

  return (
    <section id={section.slug} className="py-5 bg-white">
      <div className="container py-4">
        
        {/* BLOCO 1: Título, Subtítulo 1 e Conteúdo 1 */}
        <div className={alignClass}>
          {/* AQUI ESTÃO AS CLASSES CORRETAS: fonte-primaria e section-title */}
          <h2 className={`fonte-primaria display-4 section-title reveal-element ${revealDirection} duration-10`}>
            {section.title}
          </h2>
          
          {section.subtitle && (
            <h4 className={`fonte-terciaria section-subtitle mb-4 reveal-element ${revealDirection} duration-12`}>
              {section.subtitle}
            </h4>
          )}
          
          {section.content && (
            <p className={`fonte-terciaria lead text-dark reveal-element ${revealDirection} duration-14`} style={{ whiteSpace: 'pre-line' }}>
              {section.content}
            </p>
          )}
        </div>

        {/* BLOCO 2: Subtítulo 2 e Carrossel de Logos */}
        <div className="mb-5 mt-5 pt-4">
          {section.subtitle_2 && (
            <div className={alignClass} style={{ marginBottom: '1.5rem', paddingBottom: '0' }}>
               <h4 className={`fonte-terciaria section-subtitle reveal-element reveal-from-bottom`}>
                 {section.subtitle_2}
               </h4>
            </div>
          )}
          
          {/* Card Branco com Sombra para os Logos */}
          <div className="card border-1 rounded-4 p-4 p-md-5 reveal-element reveal-from-bottom" style={{ border: '1px solid #eaeaea' }}>
            {displayItems.length > 0 ? (
              <div id={`carouselLogos-${section.id}`} className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                  {displayItems.map((item, index) => (
                    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={item.id}>
                      <div className="row align-items-center">
                        {/* Imagem (Logo) */}
                        <div className="col-md-5 text-center mb-4 mb-md-0 border-end pe-md-4">
                          {item.images && item.images.length > 0 ? (
                            <img 
                              src={`${backendUrl}${item.images[0].image_url}`} 
                              alt={item.title} 
                              className="img-fluid p-3"
                              style={{ maxHeight: '200px', objectFit: 'contain', width: '100%', borderRadius: '8px' }}
                            />
                          ) : (
                            <div className="bg-light p-5 rounded text-muted fonte-terciaria">Sem Logo</div>
                          )}
                        </div>
                        {/* Texto (Descrição do Parceiro) */}
                        <div className="col-md-7 ps-md-4">
                          <h4 className="fonte-terciaria fw-bold mb-3" style={{ color: 'var(--cor-primaria-4)' }}>{item.title}</h4>
                          <div 
                            className="fonte-terciaria text-muted parceiro-descricao-fix" 
                            dangerouslySetInnerHTML={{ 
                              /* A MÁGICA: Limpa os espaços inquebráveis do CMS antes de imprimir */
                              __html: (item.content || item.description || '').replace(/&nbsp;/g, ' ') 
                            }} 
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                
                {/* Controles do Carrossel Discretos (Estilo Imagem 2) */}
                {displayItems.length > 1 && (
                  <>
                    <button className="carousel-control-prev" type="button" data-bs-target={`#carouselLogos-${section.id}`} data-bs-slide="prev" style={{ width: '5%', left: '-15px' }}>
                      <span className="carousel-control-prev-icon" aria-hidden="true" style={{ width: '30px', height: '30px', backgroundColor: 'transparent', filter: 'invert(1)' }}></span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target={`#carouselLogos-${section.id}`} data-bs-slide="next" style={{ width: '5%', right: '-15px' }}>
                      <span className="carousel-control-next-icon" aria-hidden="true" style={{ width: '30px', height: '30px', backgroundColor: 'transparent', filter: 'invert(1)' }}></span>
                    </button>
                  </>
                )}
              </div>
            ) : (
              <div className="text-center text-muted py-4 fonte-terciaria">Nenhum parceiro cadastrado.</div>
            )}
          </div>
        </div>

        {/* BLOCO 3: Parte Legal (Subtítulo 3 e Conteúdo 2) */}
        {(section.subtitle_3 || section.content_2) && (
          <div className="mt-5 pt-3 reveal-element reveal-from-bottom duration-14">
            <div 
              className="card border-0 shadow-sm p-4 p-md-5 text-center" 
              style={{ 
                backgroundColor: '#F9F6F0', 
                borderRadius: '20px', 
                borderTop: '5px solid var(--cor-secundaria-3)' 
              }}
            >
              {section.subtitle_3 && (
                <h4 className="fonte-terciaria fw-bold mb-3" style={{ color: 'var(--cor-primaria-4)' }}>
                  {section.subtitle_3}
                </h4>
              )}
              {section.content_2 && (
                <p className="fonte-terciaria text-muted mb-0 mx-auto" style={{ whiteSpace: 'pre-line', maxWidth: '850px', fontSize: '0.95rem', lineHeight: '1.8' }}>
                  {section.content_2}
                </p>
              )}
            </div>
          </div>
        )}

      </div>
    </section>
  );
};

export default InstitutionalWithLogos;